import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EmailVerificationPageService } from '@app/_services/email-verification-page.service';

@Component({
  selector: 'app-email-verification-page',
  templateUrl: './email-verification-page.component.html',
  styleUrls: ['./email-verification-page.component.css']
})
export class EmailVerificationPageComponent implements OnInit {
  Login: string;

  constructor(private http: HttpClient, private emailVerificationPageService: EmailVerificationPageService) { }
  verifyMessage: string;

  ngOnInit(): void {
    const url = window.location.href;
    let emailval;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      emailval = httpParams.get('emailId');
    }
    this.emailVerificationPageService.getemailVerificationPageService(emailval).subscribe(
      //  this.http.get<any>('http://192.168.0.220:8081/EDU/api/auth/verifyStudentEmail/'+paramValue).subscribe(
      res => {
        // debugger;
        //alert('ok');
        this.verifyMessage = "Thank you for verification";
        this.Login = "Please Click  Here to Login";
        //login Link


      },
      err => {
        this.verifyMessage = "Link expired Or Email already verified";
        // alert(JSON.stringify("Link expired Or Email already verified"+err.error));
        var errData = err.toString();
        //this.Login="Login";
        // alert("Error..."+errData);
      }


    )
  }
}

